import React, {Fragment, useState, useEffect, useContext} from "react";
import PropTypes from "prop-types";
import DomainTable from "root/Tables/DomainTable";
import SpinnerDiv from "root/Components/SpinnerDiv";
import AdminModuleContext from "../../AdminModuleContext";

const DomainsTab = (props) =>
{
    const domains = useContext(AdminModuleContext) ;

    useEffect(() => {
        domains.getDomains() ;
        domains.setHeader ( 'Domains') ;
    }, []);

    const onClickOrganisation = ( domain_id, mode ) =>
    {
        domains.activateDomainModal ( domain_id, mode ) ;
    }

    return (
        <Fragment>
            {domains.isDomainLoading && <SpinnerDiv/>}
            {!domains.isDomainLoading && <DomainTable data={domains.domainData} isLoading={domains.isDomainLoading} clickHandler={onClickOrganisation}/>}
        </Fragment>
    )
}

DomainsTab.defaultProps = {};

export default DomainsTab;

DomainsTab.propTypes = {
};
